<template>
    <b-form-group label="Merk Emas">
        <b-row no-gutters>
            <b-col>
                <StateInputHandler
                    :isLoading="stateMerkEmas.isLoading"
                    :error="stateMerkEmas.error"
                    errorMessage="Gagal memuat merk emas."
                    @retry="retry"
                >
                    <multiselect name="gadaiKaratEmas" v-model="input.merkEmas"
                        :disabled="!input.jenisEmas || optMerkEmas.length == 0 || (karatOpt.length != 0 && input.jenisEmas.id == 257)"
                        :options="optMerkEmas" :internal-search="true" :allow-empty="false" deselect-label="" select-label=""
                        label="name" track-by="name" placeholder="-- Please select an option --" />

                    <EmptyStateInput v-if="input.jenisEmas && optMerkEmas.length == 0" />
                </StateInputHandler>
            </b-col>
            <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ? false : true">
                <b-badge :variant="pdfReadMerk == false ? 'danger' : 'primary'" :hidden="seMerk == null ? true : false"
                    size="sm" @click="$emit('openModalSE',seMerk, 'merk', pdfReadMerk)" v-b-tooltip.hover title="SE"
                    name="jenisBarangViewBtn">
                    <i class="fa fa-info px-1"></i>
                </b-badge>
            </b-col>
        </b-row>
    </b-form-group>
</template>

<script>
import StateInputHandler from '@/components/common/StateInputHandler'
import EmptyStateInput from '@/components/common/EmptyStateInput'

export default {
    props: {
        input: { required: true },
        optMerkEmas: { required: true },
        karatOpt: { required: false },
        pdfReadMerk: { required: false },
        seMerk: { required: false },
        stateMerkEmas: { required: false },
    },
    components: {
        StateInputHandler,
        EmptyStateInput
    },
    methods: {
        retry() {
            this.$emit('getMerkEmas')
        }
    }
}
</script>